/*
@license
  Gem by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://help.archetypethemes.co/en/articles/206656

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

if (console && console.log) {
  console.log(
    "Gem theme (" +
      theme.settings.themeVersion +
      ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"
  );
}

(function () {
  "use strict";

  if (
    window.Shopify &&
    window.Shopify.theme &&
    navigator &&
    navigator.sendBeacon &&
    window.Shopify.designMode
  ) {
    navigator.sendBeacon(
      "https://api.archetypethemes.co/api/beacon",
      new URLSearchParams({
        shop: window.Shopify.shop,
        themeName:
          window.theme &&
          window.theme.settings &&
          `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
        role: window.Shopify.theme.role,
        route: window.location.pathname,
        themeId: window.Shopify.theme.id,
        themeStoreId: window.Shopify.theme.theme_store_id || 0,
        isThemeEditor: !!window.Shopify.designMode,
      })
    );
  }

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  DOMready(function () {
    document.dispatchEvent(new CustomEvent("page:loaded"));


    /*
    * Custom Code to improve accessibility of Hulk Apps and GSC Instagram Feed
    */
    const applyAriaLabels = () => {
      let applied = false;

      const mappings = [
        { selector: '.gfa-arrow-right', label: 'Next' },
        { selector: '.gfa-arrow-left', label: 'Previous' }
      ];

      mappings.forEach(({ selector, label }) => {
        document.querySelectorAll(selector).forEach((el) => {
          if (!el.hasAttribute('aria-label')) {
            el.setAttribute('aria-label', label);
            applied = true;
          }
        });
      });

      document
      .querySelectorAll('.hulkapps-tooltip img')
      .forEach((img) => {
        if (!img.hasAttribute('alt') || img.getAttribute('alt').trim() === '') {
          img.setAttribute('alt', 'More information');
          applied = true;
        }
      });

      return applied;
    };

    // Try immediately
    applyAriaLabels();

    // Observe for late-injected elements
    const observer = new MutationObserver(() => {
      applyAriaLabels();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    /*
    * ENDOF Custom Code to improve accessibility of Hulk Apps and GSC Instagram Feed
    */
  });


})();
